export const SHOP_OPERATIONS_SHOPS_URL = `shops`;
